import type { KapiDurumu } from '@isg/validation';
import { ilkKapaliKapi } from '@isg/validation';
import { KapiSebebi } from './KapiSebebi';

/**
 * SATIR SİLME SEBEBİ — P13-c (yüzey dürüstlüğü artçısı, 12.09.2026 — madde
 * 227; Kapsam §20.3b). Ek satırlarının her biri sunucudan `silmeKapisi` taşır
 * (şapka → bahçe → arşiv → kapalı kayıt → sahiplik); düğme satır başına o
 * bayraktan çizilir, **sebep bölüm başına BİR KEZ** yazılır: ilk kapalı
 * satırın sebebi (`ilkKapaliKapi`). Kullanıcı kendi ekini silebiliyor, bir
 * başkasınınkini silemiyorsa ikisini de görür — düğme kendi satırında, sebep
 * bölümün altında. Hiç kapalı satır yoksa hiçbir şey çizilmez.
 *
 * ⚠️ Ekran kural bilmez: ne yükleyen kimliğini karşılaştırır ne kapalı hâli
 * hesaplar — ikisi de sunucunun listesindedir (`yazma-kapisi-envanteri.spec`
 * `silmeKapisi` okuyan her dosyada bu bileşeni arar).
 */
export function SatirSilmeSebebi({
  kapilar,
  nesne,
  fiil,
  testId,
}: {
  kapilar: readonly KapiDurumu[];
  /** Cümlenin öznesi — ör. *"Nüshayı"*. */
  nesne: string;
  /** Cümlenin fiili — ör. *"kaldırır"*. */
  fiil: string;
  testId: string;
}): React.JSX.Element | null {
  const engel = ilkKapaliKapi(kapilar);
  if (!engel) return null;
  return <KapiSebebi durum={engel} nesne={nesne} fiil={fiil} testId={testId} />;
}
